import { useState } from "react";
import Popup from "../Popup/Popup";
import { disputeBooking } from "../../api/bookings";
import { useLoader } from '../../hooks/LoaderContext';

interface RejectPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onReject: (reason: string) => void;
  bookingId: string | null;
}

const RejectPopup: React.FC<RejectPopupProps> = ({ isOpen, onClose, onReject, bookingId }) => {
  const { setIsLoading } = useLoader();
  const [reason, setReason] = useState<string>('');
  const [isDisputed, setIsDisputed] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClose = () => {
    setReason('');
    setIsDisputed(false);
    onClose();
  };

  const handleSubmit = async () => {
    if (reason.trim()) {
      try {
        setIsLoading(true);
        setError(null);
        
        await disputeBooking(bookingId || '', {
          PONumber: "string",
          Reason: reason
        });
        onReject(reason);
        setIsDisputed(true);
      } catch (err) {
        setError('Failed to dispute booking. Please try again.');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (!isOpen) return null;

  return (
    <Popup width="33.8542vw" onClose={handleClose}>
      {!isDisputed ? (
        <>
          <h2 className="popup-title">Sure you want to dispute?</h2>
          <p>Why are you disputing this Timesheet?</p>
          
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter your reason..."
          />

          {error && <p className="error-message">{error}</p>}
          
          <div className="btns">
            <button 
              className="btn btn-confirm" 
              onClick={handleSubmit}
            >
              Yes
            </button>
            <button 
              className="btn btn-dispute" 
              onClick={handleClose}
            >
              No
            </button>
          </div>
        </>
      ) : (
        <>
          <h2 className="popup-title">Time Sheet Disputed</h2>
          <p>The Time Sheet has been disputed and will now show as disputed in your Time Sheet dashboard.</p>
          
          <div className="btns">
            <button className="btn btn-confirm" onClick={handleClose}>OK</button>
          </div>
        </>
      )}
    </Popup>
  );
};

export default RejectPopup;
